import ApiEndpointConstants from "../constants/ApiEndpointConstants";
import api from "./API";

export const getUpdateOrderUrl = (siteUrl) => {
  const value = String(siteUrl || "").trim();
  if (!value) throw new Error("The source site URL is required.");

  const normalizedUrl = /^[a-z][a-z\d+.-]*:\/\//i.test(value)
    ? value
    : `https://${value}`;
  const url = new URL(normalizedUrl);

  if (!["http:", "https:"].includes(url.protocol)) {
    throw new Error("The source site URL must use HTTP or HTTPS.");
  }

  return new URL(ApiEndpointConstants.UPDATE, `${url.origin}/`).toString();
};

export const updateOrderInformation = (siteUrl, orderDetail) => {
  return api.post(getUpdateOrderUrl(siteUrl), {
    data: JSON.stringify(orderDetail),
    saveToFile: true,
  });
};
